/* unplugin-vue-components disabled */import script from "./photo.vue?vue&type=script&setup=true&lang=js"
export * from "./photo.vue?vue&type=script&setup=true&lang=js"

import "./photo.vue?vue&type=style&index=0&id=141cd113&scoped=true&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-141cd113"]])

export default __exports__